import { twMerge } from 'tailwind-merge'

interface Dividerprops {
  className?: string
}

export const Divider = ({ className = '' }: Dividerprops) => {
  return <hr className={twMerge('border-grey-200', className)} />
}
